<template>
  <el-dialog class="advanced-binding-dialog" :title="`${data.title}字段绑定`" :visible.sync="data.visable" center :close-on-click-modal="false" :close-on-press-escape="false" append-to-body width="738px" top="8vh">
    <div class="advanced-binding-content">
      <!-- 本表字段 -->
      <div class="self-table">
        <el-input prefix-icon="el-icon-search" placeholder="搜索本表字段" v-model="firstField" clearable></el-input>
        <div class="list-content">
          <div
              v-for="item in getTableData('selfTable')"
              :key="item.id"
              class="filed-list"
              @click="itemClick(item, 'firstField')"
              :title="item.name">{{ getItemName(item) }}</div>
        </div>
      </div>
      <!-- 选中结果 -->
      <div class="select-result">
        <div class="list-content">
          <div class="filed-list" v-for="(item, i) in selectedFields" :key="i">
            <!-- 因为有一组默认值 -->
            <div class="select-content" v-if="item.firstField || item.secondField">
              <span :title="getColumnName(item.firstField, 'selfTable')">{{ getColumnName(item.firstField, 'selfTable') }}</span>
              <span class="join-png"></span>
              <span :title="getColumnName(item.secondField, 'targetTable')">{{ getColumnName(item.secondField, 'targetTable') }}</span>
              <span class="el-icon-error" @click="selectedFields.splice(i, 1)"></span>
            </div>
          </div>
        </div>
      </div>
      <!-- 目标表字段 -->
      <div class="target-table">
        <el-input prefix-icon="el-icon-search" placeholder="搜索目标表字段" v-model="secondField" clearable></el-input>
        <div class="filed-list"></div>
        <div class="list-content">
          <div
              v-for="item in getTableData('targetTable')"
              :key="item.id"
              class="filed-list"
              :class="selectedFields.find(c => c.secondField === item.id) && 'selected-filed'"
              @click="itemClick(item, 'secondField')"
              :title="item.name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirm">确定</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'advanced-binding',
  props: ['data'],
  data () {
    return {
      selectedFields: [],
      firstField: '',
      secondField: ''
    }
  },
  methods: {
    confirm () {
      this.$emit('saveFields', this.selectedFields)
      this.cancel()
    },
    cancel () {
      this.data.visable = false
    },
    itemClick (item, type) {
      // 目标表不能多选
      if (type === 'secondField' && this.selectedFields.find(c => c[type] === item.id)) return false
      // 找到空位，如果有空位则补上，否则增加
      let vacancy = this.selectedFields.find(c => !c[type])
      if (vacancy) {
        vacancy[type] = item.id
      } else {
        let result = {firstField: '', secondField: '', relationId: '', defaultValue: ''}
        result[type] = item.id
        this.selectedFields.push(result)
      }
    }
  },
  watch: {
    'data.visable' (val) {
      // secondField：目标表字段
      // firstField：本表字段
      if (val) {
        this.selectedFields = this.data.selectedFields
      }
    }
  },
  computed: {
    getColumnName () {
      return (id, table) => {
        let item = this.data[table].find(c => c.id === id)
        return item ? item.name : ''
      }
    },
    getTableData () {
      return table => {
        let keyword = table === 'selfTable' ? this.firstField : this.secondField
        // 支持拼音搜索可还行。
        return keyword ? this.data[table].filter(c => c.name.includes(keyword) || (c.pinyinFirstChar && c.pinyinFirstChar.includes(keyword)) || (c.pinyinName && c.pinyinName.includes(keyword))) : this.data[table]
      }
    },
    getItemName () {
      return item => {
        if (this.data.showTableName) {
          return item.tableName ? `${item.tableName}-${item.name}` : item.name
        } else {
          return item.name
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .advanced-binding-dialog {
    .el-dialog {
      .el-dialog__header {
        height: 40px;
        background-color: #EDEEEE;
        .el-dialog__title {
          font-size: 14px;
          color: #232323;
        }
      }
      .el-dialog__body {
        padding: 12px 10px;
        .advanced-binding-content {
          height: 560px;
          border: 1px solid #C2C3C4;
          border-radius: 4px;
          display: flex;
          .self-table, .target-table {
            width: 200px;
            border-right: 1px solid #EAEAEA;
            padding: 14px;
          }
          .target-table {
            border-right: none;
            border-left: 1px solid #EAEAEA;;
          }
          .select-result {
            width: 305px;
            padding: 14px;
          }
          .list-content {
            height: calc(100% - 35px);
            margin-top: 5px;
            overflow: auto;
            .filed-list {
              height: 26px;
              line-height: 26px;
              color: #2A2929;
              cursor: pointer;
              font-size: 12px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              width: 100%;
              &:hover {
                color: #54ABF1;
              }
              .select-content {
                display: flex;
                justify-content: space-between;
                height: 26px;
                line-height: 26px;
                vertical-align: middle;
                align-items: center;
                & > span {
                  width: 115px;
                  text-align: right;
                  color: #2A2929;
                  font-size: 12px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
                & > .join-png {
                  width: 50px;
                  text-align: center;
                  background: url('./join.png') no-repeat center;
                  height: 26px;
                }
                & > span:nth-child(3) {
                  text-align: left;
                }
                & > .el-icon-error {
                  width: 20px;
                  color: #CBCBCB;
                  &:hover {
                    color: #FB9391;
                  }
                  &:active {
                    color: #EE5757;
                  }
                }
              }
            }
            .selected-filed {
              color: #CBCBCB;
              &:hover {
                color: #CBCBCB;
              }
            }
          }
        }
      }
      .el-dialog__footer {
        .dialog-footer {
          .el-button {
            width:82px;
            height:26px;
            padding: 0;
            border-radius: 4px;
          }
          .el-button + .el-button {
            margin-left: 50px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/advanced-binding.vue